import './Marquee.css';

const WORDS = [
  'Karate Do',
  'Shito Ryu',
  'Disciplina',
  'Respeto',
  'Cúcuta Colombia',
];

function MarqueeTrack() {
  return (
    <span className="marquee__track">
      {WORDS.map((word) => (
        <span key={word} className="marquee__item">
          {word} <span className="marquee__dot">◆</span>
        </span>
      ))}
    </span>
  );
}

export default function Marquee() {
  return (
    <div className="marquee">
      <div className="marquee__strip">
        <MarqueeTrack />
        <MarqueeTrack />
      </div>
    </div>
  );
}